import React from "react";
import styled from "styled-components";

const Attribute = ({ text, value }) => (
  <Wrapper>
    <Text>{text}</Text>
    <Value>{value}</Value>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  min-width: 300px;
  padding: 10px;
`;

const Text = styled.div`
  font-weight: bold;
  width: 50%;
`;

const Value = styled.div`
  width: 50%;
`;

export default Attribute;
